import type { ComponentProps, CSSProperties } from "react";
import classNames from "classnames";
import styles from "./Skeleton.module.scss";

export type SkeletonRadius = "default" | "none" | "full";

export type SkeletonProps = ComponentProps<"div"> & {
	/** Width in px when a number, or any CSS length when a string. */
	width?: number | string;
	/** Height in px when a number, or any CSS length when a string. */
	height?: number | string;
	/**
	 * Corner style. "default" applies the standard 8px radius, "none" keeps
	 * sharp square corners, "full" renders a fully rounded shape (50%) — pass a
	 * square size for a perfect circle.
	 */
	radius?: SkeletonRadius;
};

const toCssLength = (value?: number | string): string | undefined =>
	typeof value === "number" ? `${value}px` : value;

/**
 * Placeholder preview shown while content is loading.
 */
export const Skeleton = ({
	width,
	height,
	radius = "default",
	className,
	style,
	...props
}: SkeletonProps) => {
	return (
		<div
			aria-hidden="true"
			data-radius={radius}
			className={classNames(styles["skeleton"], className)}
			style={
				{
					width: toCssLength(width),
					height: toCssLength(height),
					...style,
				} as CSSProperties
			}
			{...props}
		/>
	);
};
